import React, { useState } from 'react';
import MainLayout from '../../components/Layout/MainLayout';
import { Save, Mail, Phone, MapPin, MessageCircle } from 'lucide-react';
import './CMS.css';

const ContactCMS = () => {
  const [contactData, setContactData] = useState({
    primaryEmail: 'support@luxefurniture.com',
    secondaryEmail: 'info@luxefurniture.com',
    primaryPhone: '+91 98765 43210',
    whatsapp: '+91 98765 43210',
    address: '456, Design District, 2nd Floor, HSR Layout, Bengaluru, Karnataka - 560102',
    facebook: 'https://facebook.com/luxefurniture',
    instagram: 'https://instagram.com/luxefurniture',
    twitter: 'https://twitter.com/luxefurniture',
    linkedin: 'https://linkedin.com/company/luxefurniture'
  });

  const [saveStatus, setSaveStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setContactData(prev => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    setSaveStatus('Saving Contact Info...');
    setTimeout(() => {
      setSaveStatus('Contact information updated successfully!');
      setTimeout(() => setSaveStatus(''), 3000);
    }, 1000);
  };

  return (
    <MainLayout title="Manage Contact Details">
      <div className="contact-cms-container fade-in">
        <div className="cms-editor">
          <div className="editor-header">
            <div className="header-info">
              <h2>Contact Information</h2>
              <p>These details will be displayed on the public Contact Us page.</p>
            </div>
            <button className="save-btn" onClick={handleSave}>
              <Save size={18} /> Save Changes
            </button>
          </div>

          {saveStatus && (
            <div className={`status-toast ${saveStatus.includes('success') ? 'success' : ''}`}>
              {saveStatus}
            </div>
          )}

          <div className="editor-body scrollable-editor">
            <div className="form-grid">
              <div className="form-section">
                <h3><Mail size={18} /> Email Addresses</h3>
                <div className="form-group">
                  <label>Primary Support Email</label>
                  <input 
                    type="email" 
                    name="primaryEmail" 
                    value={contactData.primaryEmail} 
                    onChange={handleChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Business Inquiry Email</label>
                  <input 
                    type="email" 
                    name="secondaryEmail" 
                    value={contactData.secondaryEmail} 
                    onChange={handleChange} 
                  />
                </div>
              </div>

              <div className="form-section">
                <h3><Phone size={18} /> Phone Numbers</h3>
                <div className="form-group">
                  <label>Customer Care Number</label>
                  <input 
                    type="text" 
                    name="primaryPhone" 
                    value={contactData.primaryPhone} 
                    onChange={handleChange} 
                  />
                </div>
                <div className="form-group">
                  <label>WhatsApp Support Number</label>
                  <div className="input-with-icon">
                    <MessageCircle size={16} className="input-icon" />
                    <input 
                      type="text" 
                      name="whatsapp" 
                      value={contactData.whatsapp} 
                      onChange={handleChange} 
                    />
                  </div>
                </div>
              </div>

              <div className="form-section full-width">
                <h3><MapPin size={18} /> Office Address</h3>
                <div className="form-group">
                  <label>Complete Business Address</label>
                  <textarea 
                    name="address" 
                    rows={3} 
                    value={contactData.address} 
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-section full-width">
                <h3>Social Media Links</h3>
                <div className="social-links-grid">
                  <div className="form-group">
                    <label>Facebook URL</label>
                    <input 
                      type="text" 
                      name="facebook" 
                      value={contactData.facebook} 
                      onChange={handleChange} 
                    />
                  </div>
                  <div className="form-group">
                    <label>Instagram URL</label>
                    <input 
                      type="text" 
                      name="instagram" 
                      value={contactData.instagram} 
                      onChange={handleChange} 
                    />
                  </div>
                  <div className="form-group">
                    <label>Twitter (X) URL</label>
                    <input 
                      type="text" 
                      name="twitter" 
                      value={contactData.twitter} 
                      onChange={handleChange} 
                    />
                  </div>
                  <div className="form-group">
                    <label>LinkedIn URL</label>
                    <input 
                      type="text" 
                      name="linkedin" 
                      value={contactData.linkedin} 
                      onChange={handleChange} 
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default ContactCMS;
